export default "__VITE_ASSET__CaZtNLfH__"